import * as S from './styles';

interface InputViewProps {
  label: string;
  value: string | number;
  direction?: 'row' | 'column';
}

const InputView = ({ label, value, direction = 'row' }: InputViewProps) => (
  <S.Container direction={direction}>
    <span>{label}</span>
    <span>{value}</span>
  </S.Container>
);

InputView.defaultProps = {
  direction: 'row',
};

export default InputView;
